const Emoji = ({children}) => <span style={{bottom: '3px', position: 'relative'}}>{children}</span>;

export default Emoji;
